module.exports = __webpack_public_path__ + "static/media/vi.2c31b441.svg";